/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../../app.core.module.js';
import twofaOtpConfig from './2fa.otp.config.js';
import twofaOtpRoute from './2fa.otp.route.js';
import twofaOtpController from './2fa.otp.controller.js';

/**
 * This is the 2fa module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace 2fa Module
 */
angular.module('twofactorOtp', [
  // Shared modules.
  core
])
// Register config.
.config(twofaOtpConfig)
// Register route.
.config(twofaOtpRoute)
// Register controller.
.controller('twofaOtpController', twofaOtpController);



export default 'twofactorOtp';


// WEBPACK FOOTER //
// ./src/login/2fa/otp/2fa.otp.module.js